import { createAction, props } from '@ngrx/store';
import { UserHistory } from '../interfaces';
import { ViewContext } from '../enums';

export const ActionTypes = {
	add: '[History] AddHistory',
	historyLoadSuccess: '[History] HistoryLoad Success',
	reset: '[History] ResetHistory',
};

export const addHistory = createAction(
	ActionTypes.add,
	props<{ item: UserHistory; layerType: Lowercase<ViewContext>; id: string; cityId: string }>(),
);
export const HistoryLoaded = createAction(
	ActionTypes.historyLoadSuccess,
	props<{ payload: UserHistory }>(),
);
export const resetHistory = createAction(
	ActionTypes.reset,
	props<{ userHistory: UserHistory[] }>(),
);
